module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAARCAMAAAASeod7AAAAXVBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzQDM+LAAAAHnRSTlMAA+0V9+bRxp2Saj8xurd1WTghqoiBD6h3XU5LJBhdSjlSAAAAdUlEQVQoz53RRw6AMAwEQCcQamiht/3/M2kSCAg+MNfVyolNb1VMLB+Bw+URoHImd7BKDX1KsXIzYevGUZhI7LyCLsKMWeBL3ITNlui8bj0XNkqTVmCUR7/86hfn/Gmwzn+Yb+9n/98Jbn+J4fYv+3/3e99/AQjPEymf/McLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freightPriceResult/wc_dc_s02.png
// module id = Nf+F
// module chunks = 0